/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetDocumentListRequestCredential } from './getDocumentListRequestCredential';

/**
 * 航空券／EMDリスト取得APIリクエストデータ型
 */
export interface GetDocumentListRequest {
  /**
   * 検索種別<br/> eTicketAndEmdByPnrForReceipt：PNRに含まれる航空券とEMDの一覧を表示する(領収書選択用)<br/> eTicketAndEmdByPnrForETicketEmd：PNRに含まれる航空券とEMDの一覧を表示する(お客様控え表示用)
   */
  searchType: GetDocumentListRequest.SearchTypeEnum;
  /**
   * 予約番号<br/> ※予約番号、航空券番号はいずれか必須
   */
  orderId?: string;
  /**
   * 航空券番号<br/> ※予約番号、航空券番号はいずれか必須
   */
  travelDocumentId?: string;
  credential: GetDocumentListRequestCredential;
}
export namespace GetDocumentListRequest {
  export type SearchTypeEnum = 'eTicketAndEmdByPnrForReceipt' | 'eTicketAndEmdByPnrForETicketEmd';
  export const SearchTypeEnum = {
    ETicketAndEmdByPnrForReceipt: 'eTicketAndEmdByPnrForReceipt' as SearchTypeEnum,
    ETicketAndEmdByPnrForETicketEmd: 'eTicketAndEmdByPnrForETicketEmd' as SearchTypeEnum,
  };
}
